import React from 'react';
import { Helmet } from 'react-helmet';
// import { AddressResult } from '@epcbuilder/lib/models/properties';
// import { getAddressesForPostcode } from '@epcbuilder/lib/network/properties';
// import { RegisterModal } from '@/components/get-started';
import {
  Hero,
  HowDoesEpcBuilderWork,
  ImpactSection,
  InstallationMeasures,
  PersonalisedReport,
  Testimonials,
} from '@/components/landing-page';
// import OfferModal from '@/components/landing-page/OfferModal';
import WhyTrustUs from '@/components/landing-page/WhyTrustUs';
import Layout from '@/components/Layout';

const LandingPage = () => {
  return (
    <>
      <Helmet>
        <title>EPC Builder</title>
        <meta
          name="description"
          content="Improving your property's value, efficiency, and running costs with home upgrades"
        />
      </Helmet>
      <Layout title="EPC Builder Landing Page">
        <Hero />
        <HowDoesEpcBuilderWork />
        <PersonalisedReport />
        <InstallationMeasures />
        <WhyTrustUs />
        <Testimonials />
        <ImpactSection />
      </Layout>
    </>
  );
};

export default LandingPage;
